import type { IconProps } from '../types/IconProps.ts';
export const ChevronsDown: IconProps = {
    name: 'ChevronsDown',
    children: [
        `<path d="m7 6 4.7 4.87a.4.4 0 0 0 .6 0L17 6M7 13l4.7 4.87a.4.4 0 0 0 .6 0L17 13" />`,
    ]
};